import {ReactElement, useEffect, useState} from "react";
import {useSetPageTitle} from "../../hooks/useSetPageTitle";
import { getRtrTag } from "src/redux/survey/survey.endpoints";
import { FadeLoader } from "react-spinners";
import { useLocation } from "react-router-dom";
import { Button } from "src/components/ui/button";

const RTRPreviewPage = (): ReactElement => {
  useSetPageTitle('RTR Preview');
  const [rtrTag, setRtrTag] = useState('');
  const [rtrSize, setRtrSize] = useState<'300x250' | '970x250'>('300x250');
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const shareId = queryParams.get('share-id');


  const iframeStyling = `
    <style>
      html, body {
        margin: 0;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: white;
      }
    </style>`;

  useEffect(() => {
    setIsLoading(true);
    async function getData() {
      const data = await getRtrTag(shareId ?? "Error fetching RTR.", true, rtrSize);
      data && setRtrTag(data);
      setIsLoading(false);
    }
    getData();
  }, [rtrTag, rtrSize]);

  return (
    <div className="flex flex-col w-screen h-screen bg-white">
      <div className=" mt-2 ml-2">
        Select RTR Size:
        <Button
          size="med"
          className={"mr-2 ml-2 hover:bg-gray-600"}
          variant={rtrSize === '300x250' ? 'black' : 'outline'}
          onClick={() => { setRtrSize('300x250'); }}
        >
          300 x 250
        </Button>
        <Button
          className={"hover:bg-gray-600"}
          size="med"
          variant={rtrSize === '970x250' ? 'black' : 'outline'}
          onClick={() => setRtrSize('970x250')}
          title="970 x 250"
        >
          970 x 250
        </Button>
      </div>
      <div className="flex justify-center items-center grow bg-white">
        {rtrTag && !isLoading ? (
          <iframe
            srcDoc={iframeStyling + rtrTag}
            title="RTR Preview"
            width="100%"
            height="100%"
            className="h-100 w-100 border-none"
            allowFullScreen
          />
        ) : (
          <FadeLoader
            aria-label="Button loading spinner"
            color="black"
            width={3}
            height={8}
            margin={-8}
          />
        )}
      </div>
    </div>
  );
};

export default RTRPreviewPage;
